import * as React from "react";
const SvgOverviewFilled = (props) => /* @__PURE__ */ React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: 16, height: 16, viewBox: "-1 0 16 16", ...props }, /* @__PURE__ */ React.createElement("path", { fill: "#2B2B2B", d: "M5.584 16V9.776h2.592V16h5.6V3.536L6.88 0 0 3.536V16z" }));
export default SvgOverviewFilled;
